<template>
  <v-content>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>Login</v-toolbar-title>
              <v-spacer />
            </v-toolbar>
            <v-card-text>
              <v-form>
                <v-text-field
                  label="Login"
                  name="email"
                  prepend-icon="mdi-account"
                  type="text"
                  v-model="user.email"
                />
                <v-text-field
                  id="password"
                  label="Password"
                  name="password"
                  prepend-icon="mdi-lock"
                  type="password"
                  v-model="user.password"
                />
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-dialog v-model="dialog" persistent max-width="380">
                <template v-slot:activator="{ on }">
                  <v-btn color="red" dark v-on="on">Recuperar Password</v-btn>
                </template>
                <v-card>
                  <v-card-title class="headline"
                    >Esqueceu-se da password?</v-card-title
                  >
                  <v-card-text>
                    <v-text-field
                      label="Email"
                      :rules="rules"
                      hide-details="auto"
                      v-model="emailRecover"
                    ></v-text-field>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="red darken-1"
                      text
                      @click="
                        dialog = false;
                        emailRecover = '';
                      "
                      >Cancelar</v-btn
                    >
                    <v-btn color="green darken-1" text @click="recoverPassword"
                      >Recuperar</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-spacer />
              <v-btn color="primary" @click="doLogin">Login</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
/* eslint-disable */
// @ is an alias to /src
import { auth, db } from "@/firebase";
import router from '@/router'
export default {
  name: "login",
  data: () => ({
    dialog: false,
    emailRecover: null,
    user: {
      email: null,
      password: null
    },
    rules: [
      value => !!value || "Required.",
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      }
    ]
  }),
  methods: {
    doLogin() {
      auth
        .signInWithEmailAndPassword(this.user.email, this.user.password)
        .then(data => {
          db.collection("users")
            .doc(data.user.uid)
            .get()
            .then(function(doc) {
              router.push({
                path: "/"
              });
              if (!doc.exists) {
                const { email, photoURL, displayName } = data.user;
                db.collection("users")
                  .doc(data.user.uid)
                  .set({
                    email,
                    photoURL,
                    displayName
                  })
                  .then(function() {
                    console.log("Document successfully written!");
                  })
                  .catch(function(error) {
                    console.error("Error writing document: ", error);
                  });
              }
            })
            .catch(function(error) {
              console.log("Error getting document:", error);
            });

          
        })
        .catch(error => {
          console.log(error);
        });
    },
    recoverPassword() {
      auth
        .sendPasswordResetEmail(this.emailRecover)
        .then(() => {
          console.log("email enviado");
          this.emailRecover = "";
          this.dialog = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
